<template>
  <div class="wallet"  v-title data-title="钱包详情">
    <header>

    </header>
    <section>
      <router-view/>
    </section>
    <footer>
      <walletTabar></walletTabar>
    </footer>
  </div>
</template>

<script>

import walletTabar from '../../components/tabar/wallet-tabar'

export default {
  data(){
    return{

    }
  },
  components:{
    walletTabar
  }
}
</script>

<style lang="less" scoped>
  .wallet{
    section{
      margin-bottom: .97rem;
    }
  }
</style>